<template />

<script>
import Repository from '@/repositories/RepositoryFactory'
import { initialAbility } from '@/libs/acl/config'
import { mapAbility } from '@/libs/helper'
import { mapStores } from 'pinia'
import useRoleStore from '@/store-pinia/useRoleStore'
import useJwt from '@/auth/jwt/useJwt'
import useAppStore from '@/store-pinia/useAppStore'

const ProfileRepository = Repository.get('profile')
const ServiceSystemRepository = Repository.get('serviceSystem')

export default {
  computed: {
    // note we are not passing an array, just one store after the other
    // each store will be accessible as its id + 'Store'
    ...mapStores(useRoleStore),
  },
  beforeMount() {},
  beforeCreate() {
    this.$OneSignal.showSlidedownPrompt()
  },

  created() {
    this.$OneSignal.isPushNotificationsEnabled().then(response => {
      console.log('Is enable notification ', response)
    })
    this.getProfile()
  },

  methods: {
    handleServicePermissions(data) {
      const hasAllProjects = data.projects?.some(p => p.projectId === 'ALL_PROJECT')
      const hasAllCategories = data.serviceCateAndType?.some(c => c.serviceCategoryCode === 'ALL_CATEGORY')
      const hasAllTypes = data.serviceCateAndType?.some(c => c.serviceTypes?.some(t => t.code === 'ALL_TYPE'))
      const hasAllSubTypes = data.serviceCateAndType?.some(c => c.serviceTypes?.some(t => t.subTypes?.some(st => st.code === 'ALL_SUBTYPE')))

      const getProjects = () => {
        if (hasAllProjects) {
          return ['ALL_PROJECT']
        }
        return data.projects?.map(p => p.projectId).filter(Boolean) || []
      }

      const getServiceCategories = () => {
        if (hasAllCategories) {
          return ['ALL_CATEGORY']
        }
        return data.serviceCateAndType?.map(c => c.serviceCategoryCode).filter(Boolean) || []
      }

      const getServiceTypes = () => {
        if (hasAllTypes) {
          return ['ALL_TYPE']
        }
        return data.serviceCateAndType?.flatMap(c => c.serviceTypes?.map(t => t.code).filter(Boolean)).filter(code => code !== 'ALL_TYPE') || []
      }

      const getServiceSubTypes = () => {
        if (hasAllSubTypes) {
          return ['ALL_SUBTYPE']
        }
        return data.serviceCateAndType?.flatMap(c => c.serviceTypes?.flatMap(t => t.subTypes?.map(st => st.code).filter(Boolean)).filter(code => code !== 'ALL_SUBTYPE')) || []
      }

      this.appStore.setServiceCategories(data.allService || [])

      this.appStore.setAllowed({
        projects: getProjects(),
        serviceCategories: getServiceCategories(),
        serviceTypes: getServiceTypes(),
        serviceSubTypes: getServiceSubTypes(),
      })

      ServiceSystemRepository.getEachBadgeCount()
        .then(res => {
          const userId = data.id
          const statuses = res.data.data
          const serviceCategories = data.allService || []

          const badgeCount = {
            all: 0,
            pendingPrice: 0,
            pendingDispatch: 0,
          }

          serviceCategories.forEach(category => {
            badgeCount[category.code] = {
              all: 0,
              pendingPrice: 0,
              pendingDispatch: 0,
            }
          })

          statuses.forEach(status => {
            const filteredServices = status.services.filter(service => {
              const operatorCondition = !service.assignedOperatorId || service.assignedOperatorId === userId
              const projectCondition = this.appStore.allowedProjects.includes('ALL_PROJECT') || this.appStore.allowedProjects.includes(service.projectId)
              const categoryCondition = this.appStore.allowedServiceCategories.includes('ALL_CATEGORY') || this.appStore.allowedServiceCategories.includes(service.serviceCategory?.code)
              const typeCondition = this.appStore.allowedServiceTypes.includes('ALL_TYPE') || this.appStore.allowedServiceTypes.includes(service.serviceType?.code)
              const subTypeCondition = this.appStore.allowedServiceSubTypes.includes('ALL_SUBTYPE') || this.appStore.allowedServiceSubTypes.includes(service.serviceSubType?.code)

              return operatorCondition && projectCondition && categoryCondition && typeCondition && subTypeCondition
            })

            badgeCount[status.status] = filteredServices.length
            badgeCount.all += filteredServices.length

            filteredServices.forEach(service => {
              const categoryCode = service.serviceCategory?.code
              if (categoryCode && badgeCount[categoryCode]) {
                badgeCount[categoryCode][status.status] = (badgeCount[categoryCode][status.status] || 0) + 1
                badgeCount[categoryCode].all += 1
              }
            })
          })

          this.appStore.setServiceBadgeCount(badgeCount)
        })
    },
    getProfile() {
      ProfileRepository.getProfile().then(response => {
        const data = response?.data?.data
        if (data) {
          this.appStore.setProfile(data)
          this.appStore.setBoundTelegram(data.isBindTelegram)

          this.roleStore.setAbility(data.ability)
          this.$store.commit('profile/UPDATE_PROFILE', data)
          localStorage.setItem(useJwt.jwtConfig.storageUserDataKeyName, JSON.stringify(data))
          let newAbility = [...initialAbility]

          this.handleServicePermissions(data)

          if (data.ability) {
            newAbility = mapAbility(data, newAbility, initialAbility)
          }
          // Updating user ability in CASL plugin instance
          this.$ability.update([])
          this.$ability.update(newAbility)
          if (!process.env.VUE_APP_SKIP_ONE_SIGNAL) {
            this.$OneSignal
              .init({
                appId: window.VUE_APP_ONE_SIGNAL_APP_ID,
                promptOptions: {
                  showCredit: false,
                  actionMessage: this.$t(
                    'notification.requireAllowNotification',
                  ),
                  acceptButton: this.$t('notification.acceptButton'),
                  acceptButtonText: this.$t('notification.acceptButtonText'),
                  cancelButton: this.$t('notification.cancelButton'),
                  cancelButtonText: this.$t('notification.cancelButtonText'),
                },
                welcomeNotification: {
                  disable: false,
                },
              })
              .then(() => {
                console.log('INIT Notification')
                // this.$OneSignal.setExternalUserId(data.id.toString());
                // this.$OneSignal
                //   .sendTags({
                //     merchantUserId: data.id,
                //     merchantId: data.merchantId,
                //   })
                //   .then(() => {
                //     console.log("Tags set");
                //   });
              })

            this.$OneSignal
              .sendTags({
                merchantUserId: data.id,
                merchantId: data.merchantId,
              })
              .then(() => {
                console.log('Tags set')
              })
          }
        }
      })
    },
  },
  setup() {
    const appStore = useAppStore()

    return {
      appStore,
    }
  },
}
</script>
